export class AdType {
    type: number;
    name: string;
    maxAmount: number;
    used: number;
    sizeOptions: string[];
}